export default __webpack_public_path__ + "static/media/tk.ddf9eb13.png";